import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import {
  upcomingEventTitle,
  upcomingEventImage,
  upcomingEvent,
  upcomingEventWrapper,
} from "../../css/upcoming-event.module.css";

const UpcomingEvent = ({ event }) => {
  return (
    <div className={upcomingEventWrapper}>
      <div className={upcomingEvent}>
        <div className={upcomingEventImage}>
          <GatsbyImage
            image={event.mainImage.childImageSharp.gatsbyImageData}
            alt={event.eventTitle}
            imgStyle={{ objectFit: "cover" }}
            style={{ height: "100%" }}
          />
        </div>
        <div className={upcomingEventTitle}>
          <p>{event.eventTitle}</p>
          <p>{event.eventDescription.split(".").slice(0, 1).join(".") + "."}</p>
          <p>
            <time datetime={event.eventStart}>
              {formatDate(event.eventStart)}
            </time>
          </p>
          <Link to={`/event/${event.slug}`}>Read more</Link>
        </div>
      </div>
    </div>
  );
};

function formatDate(dateString) {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const formatter = new Intl.DateTimeFormat([], options);
  return formatter.format(new Date(dateString));
}

export default UpcomingEvent;
